import {createAction} from 'redux-act';

export const SET_ACTIVATE_SURVEY = createAction('feedback/SET_ACTIVATE_SURVEY');
export const GET_FEEDBACK_DATA = createAction('feedback/GET_FEEDBACK_DATA');
export const GET_FEEDBACK_DATA_SUCCESS = createAction(
  'feedback/GET_FEEDBACK_DATA_SUCCESS'
);
export const SET_LOADING = createAction('feedback/SET_LOADING');
export const CLEAR_FEEDBACK_DATA = createAction('feedback/CLEAR_FEEDBACK_DATA');
export const SET_FILTER = createAction('feedback/SET_FILTER');

// Customer Feedback page redesign. Talks to merchant-dashboard-bff
// aggregator: GET /feedback/summary, GET /feedback/reviews,
// GET /feedback/reviews/{id}/context, POST /feedback/reviews/{id}/contact-status.

export const CLEAR_FEEDBACK_REDESIGN_STATE = createAction(
  'feedback/CLEAR_REDESIGN_STATE'
);

export const GET_FEEDBACK_SUMMARY = createAction('feedback/GET_SUMMARY');
export const GET_FEEDBACK_SUMMARY_SUCCESS = createAction(
  'feedback/GET_SUMMARY_SUCCESS'
);
export const GET_FEEDBACK_SUMMARY_FAILURE = createAction(
  'feedback/GET_SUMMARY_FAILURE'
);

// payload: {status, page, limit, append}. status is the BFF filter
// (needs_reply / contacted / skipped) or null for all. append=true keeps
// existing items (infinite scroll); default replaces them.
export const GET_FEEDBACK_REVIEWS = createAction('feedback/GET_REVIEWS');
export const GET_FEEDBACK_REVIEWS_SUCCESS = createAction(
  'feedback/GET_REVIEWS_SUCCESS'
);
export const GET_FEEDBACK_REVIEWS_FAILURE = createAction(
  'feedback/GET_REVIEWS_FAILURE'
);
export const CLEAR_FEEDBACK_REVIEWS = createAction('feedback/CLEAR_REVIEWS');

// payload: reviewId
export const GET_FEEDBACK_REVIEW_CONTEXT = createAction(
  'feedback/GET_REVIEW_CONTEXT'
);
export const GET_FEEDBACK_REVIEW_CONTEXT_SUCCESS = createAction(
  'feedback/GET_REVIEW_CONTEXT_SUCCESS'
);
export const GET_FEEDBACK_REVIEW_CONTEXT_FAILURE = createAction(
  'feedback/GET_REVIEW_CONTEXT_FAILURE'
);

// payload: {reviewId, status} where status is emailed | called | skipped.
export const SET_FEEDBACK_CONTACT_STATUS = createAction(
  'feedback/SET_CONTACT_STATUS'
);
export const SET_FEEDBACK_CONTACT_STATUS_SUCCESS = createAction(
  'feedback/SET_CONTACT_STATUS_SUCCESS'
);
export const SET_FEEDBACK_CONTACT_STATUS_FAILURE = createAction(
  'feedback/SET_CONTACT_STATUS_FAILURE'
);

// payload: {reviewId, subject, body, customerEmail}
export const SEND_FEEDBACK_REPLY = createAction('feedback/SEND_REPLY');
export const SEND_FEEDBACK_REPLY_SUCCESS = createAction(
  'feedback/SEND_REPLY_SUCCESS'
);
export const SEND_FEEDBACK_REPLY_FAILURE = createAction(
  'feedback/SEND_REPLY_FAILURE'
);

// Feedback-reply promo discount (GROW-2260). One active discount per location,
// marked by marketing.feedbackReply.isEnabled and enforced by loyalty-service.
// The code+min are injected into suggested replies.
export const GET_FEEDBACK_DISCOUNT = createAction(
  'feedback/GET_FEEDBACK_DISCOUNT'
);
export const GET_FEEDBACK_DISCOUNT_SUCCESS = createAction(
  'feedback/GET_FEEDBACK_DISCOUNT_SUCCESS'
);
export const GET_FEEDBACK_DISCOUNT_FAILURE = createAction(
  'feedback/GET_FEEDBACK_DISCOUNT_FAILURE'
);

// payload: {discount, postCallback, errorCallback}
export const CREATE_FEEDBACK_DISCOUNT = createAction(
  'feedback/CREATE_FEEDBACK_DISCOUNT'
);
export const CREATE_FEEDBACK_DISCOUNT_SUCCESS = createAction(
  'feedback/CREATE_FEEDBACK_DISCOUNT_SUCCESS'
);
export const CREATE_FEEDBACK_DISCOUNT_FAILURE = createAction(
  'feedback/CREATE_FEEDBACK_DISCOUNT_FAILURE'
);

// payload: {id, discount, postCallback, errorCallback}
export const UPDATE_FEEDBACK_DISCOUNT = createAction(
  'feedback/UPDATE_FEEDBACK_DISCOUNT'
);
export const UPDATE_FEEDBACK_DISCOUNT_SUCCESS = createAction(
  'feedback/UPDATE_FEEDBACK_DISCOUNT_SUCCESS'
);
export const UPDATE_FEEDBACK_DISCOUNT_FAILURE = createAction(
  'feedback/UPDATE_FEEDBACK_DISCOUNT_FAILURE'
);
